import axios from "axios";

export interface PerformanceFilters {
  academicSessionId?: string;
  classId?: string;
  sectionId?: string;
  studentId?: string;
  examId?: string;
}

export interface PerformanceExamResult {
  examId: string;
  examName: string;
  marksObtained: number;
  maxMarks: number;
  grade: string | null;
}

export interface PerformanceMatrixRow {
  subjectId: string;
  subjectName: string;
  examResults: PerformanceExamResult[];
}

export interface PerformanceSummary {
  overallPercentage: number;
  overallGrade: string;
  totalMarksObtained: number;
  totalMaxMarks: number;
}

export interface PerformanceDashboardResponse {
  student: any | null;
  session: any | null;
  class: any | null;
  section: any | null;
  subjects: { id: string; name: string; code?: string | null }[];
  exams: { id: string; name: string }[];
  performanceMatrix: PerformanceMatrixRow[];
  summary: PerformanceSummary | null;
}

export interface CreatePerformancePayload {
  studentId: string;
  studentSessionRecordId?: string;
  academicSessionId?: string;
  classId?: string;
  sectionId?: string;
  examId: string;
  subjectId: string;
  marksObtained: number;
  maxMarks: number;
  grade?: string;
  remarks?: string;
}

export async function fetchPerformanceDashboard(
  filters: PerformanceFilters,
): Promise<PerformanceDashboardResponse> {
  const params: any = {};
  if (filters.academicSessionId) params.academicSessionId = filters.academicSessionId;
  if (filters.classId) params.classId = filters.classId;
  if (filters.sectionId) params.sectionId = filters.sectionId;
  if (filters.studentId) params.studentId = filters.studentId;
  if (filters.examId) params.examId = filters.examId;

  const res = await axios.get<PerformanceDashboardResponse>(
    "/scholar-register/student-performance",
    { params },
  );
  return res.data;
}

export async function createOrUpdatePerformance(
  payload: CreatePerformancePayload,
) {
  const res = await axios.post(
    "/scholar-register/student-performance",
    payload,
  );
  return res.data;
}

export async function deletePerformance(id: string) {
  const res = await axios.delete(
    `/scholar-register/student-performance/${id}`,
  );
  return res.data;
}
